import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TuiAppearance, TuiButton, TuiDialogContext, TuiError, TuiTextfield } from '@taiga-ui/core';
import { TuiForm } from '@taiga-ui/layout';
import { FormControl, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TuiAutoFocus } from '@taiga-ui/cdk';
import { injectContext } from '@taiga-ui/polymorpheus';
import { AuthModalFacade } from './auth-modal.facade';
import { AuthModalStore } from './auth-modal.store';
import { TuiButtonLoading } from '@taiga-ui/kit';
import { User } from '../../core/auth/auth.model';
import { USERNAME_MAX_LENGTH } from '../../core/auth/auth.const';

@Component({
  selector: 'app-auth-modal',
  imports: [
    TuiTextfield,
    TuiForm,
    FormsModule,
    TuiButton,
    TuiAutoFocus,
    TuiAppearance,
    ReactiveFormsModule,
    TuiButtonLoading,
    TuiError
  ],
  templateUrl: './auth-modal.html',
  styleUrl: './auth-modal.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [AuthModalStore, AuthModalFacade]
})
export class AuthModal {
  protected readonly context = injectContext<TuiDialogContext<User | string, string>>();
  readonly #authModalFacade = inject(AuthModalFacade);
  protected readonly authModalStore = inject(AuthModalStore);

  protected readonly email = new FormControl<string>('', {
    nonNullable: true,
    validators: [Validators.required, Validators.email, Validators.maxLength(USERNAME_MAX_LENGTH)]
  });

  protected login() {
    const email = this.email.value;

    this.#authModalFacade
      .login(email)
      .subscribe((user) => this.context.completeWith(user ?? email));
  }
}
